import { render } from "./AppErrorAlert.vue?vue&type=template&id=b8eab8ea"
import script from "./AppErrorAlert.vue?vue&type=script&lang=js"
export * from "./AppErrorAlert.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__